import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Col, Row, Form } from 'react-bootstrap';

import { bindActionCreators, compose } from 'redux';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { getFormValues, reduxForm } from 'redux-form';

import { DataTable } from '../../../common/components/index';
import CreateSourceButton from '../../source/components/CreateSourceButton/CreateSourceButton';
import { InternalButtonBar } from '../../layout/components';
import { refreshData } from '../../../common/components/DataTable/redux/dataTableActions';
import { actions } from '../../source/redux/sourceActions';
import formatDateTime from '../../../helpers/formatDateTime';

const BrokerSources = ({
  dispatch,
  change,
  handleSubmit,
  formValues,
  actions,
  resource,
}) => {
  const updateSource = (id) => {
    Promise.resolve(actions.updateSource(id, formValues)).then(() => {
      refreshList();
    });
  };

  const handleChangeSourceStatus = (row, cellName, cellValue) => {
    if (row.status !== cellValue) {
      Promise.resolve(dispatch(change('data.attributes.status', cellValue))).then(() => {
        updateSource(row.id);
      });
    }
  };

  const refreshList = () => {
    dispatch(refreshData('source'));
  };
  const cellEditProp = {
    mode: 'dbclick',
    blurToSave: true,
    afterSaveCell: handleChangeSourceStatus,
  };

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <DataTable
          source="/sources"
          name="source"
          showTotal
          autoFilter={resource.data.id}
          autoFilterType="filter[broker]"
          cellEdit={cellEditProp}
        >
          <TableHeaderColumn dataField="id" isKey hidden />

          <TableHeaderColumn dataField="name">Name</TableHeaderColumn>

          <TableHeaderColumn
            dataField="created_at"
            dataFormat={formatDateTime}
            width={'180px'}
            dataSort
          >
            Created
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="status"
            dataSort
            width={'180px'}
            editable={{
              type: 'select',
              options: {
                values: [
                  { value: 'active', text: 'Active' },
                  { value: 'inactive', text: 'Inactive' },
                ],
              },
            }}
          >
            Status
          </TableHeaderColumn>
        </DataTable>
      </Form>

      <Row>
        <Col sm={12}>
          <InternalButtonBar
            buttons={[
              {
                permissions: ['marketing.source_create'],
                button: (
                  <CreateSourceButton
                    label={'Add a new source for ' + resource.data.attributes.name}
                    broker={resource.data}
                    callback={refreshList}
                  />
                ),
              },
            ]}
          />
        </Col>
      </Row>
    </>
  );
};

BrokerSources.propTypes = {
  dispatch: PropTypes.func.isRequired,
  resource: PropTypes.object.isRequired,
};

const FORM_NAME = 'UpdateBrokerSourceForm';

export default compose(
  connect(
    (state) => ({
      formValues: getFormValues(FORM_NAME)(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(actions, dispatch),
    }),
  ),
  reduxForm({ form: FORM_NAME }),
)(BrokerSources);
